import React from 'react';

import { Badge, Box, Tab } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

const TabBadge = ({
    color = 'error',
    content = '',
    label,
    moduleName = null,
    value,
    visible,
    ...props
}) => (
    <Tab
        {...props}
        label={
            <Box alignItems="center" display="flex">
                <Badge
                    color={color}
                    content={content}
                    invisible={!visible}
                    variant="dot"
                >
                    {label}
                </Badge>
                {moduleName}
            </Box>
        }
        value={value}
    />
);

TabBadge.propTypes = {
    color: PropTypes.string,
    content: PropTypes.string,
    label: PropTypes.string,
    moduleName: PropTypes.string,
    onClick: PropTypes.func,
    value: PropTypes.string,
    visible: PropTypes.bool,
};

export default TabBadge;
